// extracted by mini-css-extract-plugin
export default {"c2pButton":"C2Pbutton_c2pButton__XBtWS","secondaryCTA":"C2Pbutton_secondaryCTA__jLQ4k","linkCTA":"C2Pbutton_linkCTA__+UQDI"};